export default {
  standard: ['E2', 'A2', 'D3', 'G3', 'B3', 'E4']
}
